import styled from "styled-components";

export const PreviewContainer = styled.div`
  height: 100%;
  width: 100%;
`;
export const StyledPreview = styled.div`
  height: 100%;
`;
